<script>

    import ModalContainer from '../$components/modal.container.svelte'

    import Zipcodes from './component.zipcodes.svelte'
    import CoverageUpload from './component.upload.svelte'
    import CoverageDownload from './component.download.svelte'

    import TitleHero from '../$components/title.hero.svelte'
    import View from '../$layouts/view.layout.svelte'

</script>

<View>
    <div>
        <TitleHero title="Cobertura TIL" subtitle="Consulta y gestión de cobertura TIL" />
        <Zipcodes />
    </div>
</View>

<ModalContainer id="coverage_upload_modal" title="Subir cobertura" >
    <CoverageUpload />
</ModalContainer>

<ModalContainer id="coverage_download_modal" title="Descargar cobertura" >
    <CoverageDownload />
</ModalContainer>